module.exports = __webpack_public_path__ + "img/LoGobetflix.dd6e1548.png";